import { render, staticRenderFns } from "./DremioPanel.vue?vue&type=template&id=aaf23e4c"
import script from "./DremioPanel.vue?vue&type=script&lang=js"
export * from "./DremioPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports